import * as React from "react";

function SvgBlob1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}><path d="M188.5 31.9c12.9 15.9 12.5 43.3 10.3 77.1s-6.2 74.2-26.2 86.5-56.1-3.3-89.4-21.2-63.7-38.1-76.4-69.8C-5.9 73-.8 29.9 21.6 11.7 44-6.4 83.8.5 116.7 6.1s59 10 71.8 25.8z" /></svg>;
}

export default SvgBlob1;